<template>
    <div class="form-feed">
        <div
            v-if="!isProfileFormEdit"
            class="gcmcn-form-title"
        >
            Add Profile
        </div>
        <div
            v-else
            class="gcmcn-form-title"
        >
            Edit Profile
        </div>
        <div
            v-if="formInitialised"
            class="gcmcn-card form-feed"
        >
            <el-form :model="form" :rules="rules" ref="form">
                <div class="gcmcn-inputs-container"  style="justify-content: flex-start;">
                    <div class="flex-basis-10" style="margin-right: 15px;">
                        <el-form-item class="gcmcn-form-input" prop="display_name">
                            <div class="gcmcn-form-label">Name</div>
                            <el-input
                                size="mini"
                                v-model="form.display_name"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-10">
                        <el-form-item
                            class="gcmcn-form-input"
                            prop="aws_region_uid"
                        >
                            <div class="gcmcn-form-label">AWS Region</div>
                            <el-select
                                v-model="form.aws_region_uid"
                                popper-class="gcmcn-popper"
                                size="mini"
                                placeholder="Select a region"
                                @change="changedRegion"
                            >
                                <el-option
                                    v-for="region in awsregionsSortedByName"
                                    :key="region.uid"
                                    :label="region.display_name"
                                    :value="region.uid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-4">
                        <el-form-item class="gcmcn-form-input" prop="start_time">
                            <div class="gcmcn-form-label">Takers</div>
                            <el-select
                                v-model="form.takers"
                                multiple
                                placeholder="Select"
                                size="mini"
                                popper-class="gcmcn-popper"
                                value-key="uid"
                                :disabled="disableTakerSelected"
                            >
                                <el-option
                                    v-for="taker in currentChannelAvailableTakers"
                                    :key="taker.uid"
                                    :label="taker.name"
                                    :value="taker">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="validateForm"
                    >
                        Save
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

    components: {
    },

    props: {
        selectedProfile:{
            type: Object,
        },
        isProfileFormEdit:{
            type: Boolean,
            default: false,
        },
        channel: {
            type: Object,
            required: true,
        },
        broadcastRights: {
            type: Array,
            required: true,
        },
        profiles: {
            type: Array,
            required: true,
        },

    },

    data (){
        return {
            form: {
                display_name:'',
                takers: [],
                aws_region_uid: '',
            },
            formInitialised: false,
            disableTakerSelected: false,
        };
    },

    computed: {
        ...mapGetters([
            'takers',
            'awsregionsSortedByName',
        ]),
        rules (){
            let rules = {
                display_name: [{ type: 'string', required: true, message: 'Profile name is required' }],
                takers: [{ type: 'array' }],
                aws_region_uid: [{ required: true, message: 'AWS region is required' }],
            };
            return rules;
        },
        currentChannelAvailableTakers(){
            if(this.channel.scopes && this.channel.scopes.entity_uid){
                let takersInRegion = [];
                let takerWithRightsUids = this.broadcastRights.map(right => right.taker_uid);
                takersInRegion = this.takers.filter(taker => {
                    return takerWithRightsUids
                        .includes(taker.uid) && taker.aws_region_uid === this.form.aws_region_uid;
                });
                let unavailableTakerUids = this.profiles.flatMap(profile => profile.takers_uid);
                let availableTakers = takersInRegion
                    .filter(taker => !unavailableTakerUids.includes(taker.uid));

                return availableTakers;
            }
        },
    },
    watch: {
        rules: {
            handler (){
                this.$nextTick( () => {
                    this.$refs.form.clearValidate();
                });
            },
            deep: true,
        },
    },
    mounted(){
        this.setForm();
    },
    methods: {
        changedRegion(){
            this.form.takers = [];
        },
        setForm (){
            if(this.isProfileFormEdit){
                this.$set(this, 'form', JSON.parse(JSON.stringify(this.selectedProfile)));
                this.form.display_name = this.selectedProfile.display_name;
                this.form.takers = this.selectedProfile.takers;
            }else{
                this.$set(this, 'form', {
                    name: '',
                    takers: [],
                    aws_region_uid: '',
                });
            }
            this.formInitialised = true;
        },
        validateForm (){
            let takersUid = this.form.takers.map(taker => taker.uid);
            this.$refs.form.validate((valid) => {
                if(valid){
                    let form = JSON.parse(JSON.stringify(this.form));
                    form.channel_uid = this.channel.uid;
                    form.takers_uid = this.form.takers ? takersUid : [];
                    let postData = { item: form };
                    postData.scopes = {'X-Entity-Uid': this.channel.scopes.entity_uid};
                    postData.url = this.$store.state.api.meta.listModels.blankingProfiles.url;
                    postData.model = 'blankingProfiles';
                    if(this.isProfileFormEdit){
                        postData.item.uid = this.selectedProfile.uid;
                    } else {
                        postData.item.name = this.form.display_name;
                    }
                    let actionType = this.isProfileFormEdit ? 'edition' : 'creation';
                    let action = this.isProfileFormEdit ? 'patchItem' : 'createItem';
                    return this.$store.dispatch(action, postData).then(() => {
                        this.$message.success(`Success on profile ${actionType}.`);
                        this.$emit('leave-form-view');
                        this.$emit('profile-created');
                    }).catch((e) => {
                        console.error(e);
                        this.$message.error(`Error on profile ${actionType}.`);
                    });
                }
            });
        },
        leave (){
            this.$emit('leave-form-view');
        },
    },
};
</script>

<style lang="scss">
.form-feed{
    .el-switch__label:not(.is-active){
        color: #858d96;
    }
    .crop-rules{
        text-transform: initial;
        color: #bbb;

    }
    .gcmcn-danger-btn{
        margin-top: 20px;
        margin-bottom: 20px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/Profiles/profile-form.vue